<template>
  <div>
    <a
      v-show="false"
      ref="showDialog"
      class="btn add-btn"
      href="#"
      data-toggle="modal"
      data-target="#dialogFormSplitGroup"
    >
      <i class="fa fa-tags"></i> Edit
    </a>

    <div
      id="dialogFormSplitGroup"
      class="modal custom-modal fade split-group-modal"
      role="dialog"
      aria-labelledby="splitGroupTitle"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="split-title">
              <span class="split-title-icon"><i class="fa fa-users"></i></span>
              <div>
                <h5 id="splitGroupTitle" class="modal-title">Pisah Grup Kontak</h5>
                <p>Bagi kontak ke beberapa grup baru secara otomatis.</p>
              </div>
            </div>
            <button
              ref="dismisModal"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Tutup"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div v-if="errorMessage" class="split-error" role="alert">
              <i class="fa fa-exclamation-circle"></i>
              <span>{{ errorMessage }}</span>
            </div>

            <div class="split-source">
              <div class="split-field">
                <label>Grup Asal</label>
                <input
                  disabled
                  type="text"
                  class="form-control"
                  :value="form_data.name"
                />
              </div>
              <div class="split-field">
                <label>Jumlah Kontak</label>
                <span class="split-count">
                  <i class="fa fa-users"></i>
                  {{ selectedGroup ? formatNumber(selectedGroup.total_group) : 0 }}
                </span>
              </div>
            </div>

            <div class="split-grid">
              <div class="split-field">
                <label for="splitContactLimit">Batas Kontak per Grup</label>
                <input
                  id="splitContactLimit"
                  v-model="form_data.limit_per_group"
                  type="number"
                  class="form-control"
                  :min="minLimit"
                  :disabled="submitting"
                  @input="errorMessage = ''; hitungJumlahGrup(selectedGroup && selectedGroup.total_group, form_data.limit_per_group)"
                />
                <small class="split-help">Minimal {{ minLimit }} kontak per grup.</small>
              </div>

              <div class="split-toggle-card">
                <div class="split-toggle-copy">
                  <strong>Hapus grup asal setelah pemisahan</strong>
                  <small>Grup asal akan dihapus permanen.</small>
                </div>
                <a-switch
                  v-model="form_data.is_delete_original"
                  :disabled="submitting"
                />
              </div>
            </div>

            <div class="split-info">
              <i class="fa fa-info-circle"></i>
              <div>
                Pemisahan akan membuat
                <span class="split-info-count">{{ jumlahGrup }}</span>
                grup baru secara otomatis.
                <template v-if="form_data.is_delete_original">
                  Grup asal akan dihapus permanen setelah pemisahan.
                </template>
              </div>
            </div>

            <div v-if="form_data.is_delete_original" class="split-warning">
              <i class="fa fa-exclamation-triangle"></i>
              <div>
                <strong>Perhatian</strong>
                <p>
                  Grup asal akan dihapus permanen. Kontak tetap dibagi ke grup
                  hasil pemisahan dan tidak dihapus dari akun.
                </p>
              </div>
            </div>
          </div>

          <div class="modal-footer split-actions">
            <button
              type="button"
              class="btn split-btn split-btn-secondary"
              data-dismiss="modal"
              :disabled="submitting"
            >
              Batal
            </button>
            <button
              type="button"
              class="btn split-btn split-btn-primary"
              :disabled="submitting"
              @click="handleSubmit"
            >
              <i class="fa" :class="submitting ? 'fa-spinner fa-spin' : 'fa-check'"></i>
              {{ submitting ? "Memproses..." : "Submit" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const minLimit = 10;

export default {
  name: "formSplitGroup",
  props: {
    value: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      minLimit,
      submitting: false,
      errorMessage: "",
      form_data: {
        id: "",
        name: "",
        limit_per_group: minLimit,
        is_delete_original: false
      },
      jumlahGrup: 0
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (!newVal) {
          this.form_data = {
            id: "",
            name: "",
            limit_per_group: minLimit,
            is_delete_original: false
          };
          this.jumlahGrup = 0;
          this.errorMessage = "";
          return;
        }
        this.form_data = {
          id: newVal.id,
          name: String(newVal.name || "").split("~")[0],
          limit_per_group: minLimit,
          is_delete_original: false
        };
        this.errorMessage = "";
        this.hitungJumlahGrup(newVal.total_group, minLimit);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    selectedGroup: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    formatNumber(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return "0";
      }
      const numeric = Number(value);
      return isFinite(numeric) ? numeric.toLocaleString("id-ID") : "0";
    },
    getErrorMessage(error, fallback) {
      let message = "";
      if (error && error.response && error.response.data) {
        message = error.response.data.msg || error.response.data.message || "";
      }
      if (!message && error && error.message) {
        message = error.message;
      }
      message = String(message)
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<[^>]*>/g, "")
        .trim();
      if (!message) {
        return fallback;
      }
      if (/sql|select |table|column|backend|redis|worker|stack|trace|invalid|failed|error/i.test(message)) {
        return fallback;
      }
      return message;
    },
    hitungJumlahGrup(totalAnggota, limitKontak) {
      const total = Number(totalAnggota);
      const limit = Number(limitKontak);
      if (!isFinite(total) || total < 0 || !isFinite(limit) || limit <= 0) {
        this.jumlahGrup = 0;
        return;
      }
      this.jumlahGrup = Math.ceil(total / limit);
    },
    showDialog() {
      if (this.$refs.showDialog) {
        this.$refs.showDialog.click();
      }
    },
    async handleSubmit() {
      if (this.submitting) {
        return;
      }
      this.errorMessage = "";
      const total = Number(this.selectedGroup && this.selectedGroup.total_group);
      const limit = Number(this.form_data.limit_per_group);

      if (!isFinite(total) || total < this.minLimit) {
        this.errorMessage =
          "Jumlah kontak grup asal minimal " + this.minLimit + " kontak.";
        return;
      }
      if (!isFinite(limit) || limit < this.minLimit) {
        this.errorMessage =
          "Batas kontak per grup minimal " + this.minLimit + " kontak.";
        return;
      }

      this.submitting = true;
      try {
        const confirmation = await this.$fire({
          title: "Pisah grup kontak ini?",
          text: this.form_data.is_delete_original
            ? "Kontak akan dibagi ke grup baru dan grup asal akan dihapus permanen."
            : "Kontak akan dibagi ke beberapa grup baru. Grup asal tetap dipertahankan.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya, pisahkan",
          cancelButtonText: "Batal",
          confirmButtonColor: "#f39c12"
        });
        if (!this.isConfirmed(confirmation)) {
          this.submitting = false;
          return;
        }

        const response = await this.$store.dispatch("contact/splitContactGroup", {
          id: this.form_data.id,
          limit_per_group: limit,
          is_delete_original: this.form_data.is_delete_original ? 1 : 0
        });
        this.$fire({
          title: "Berhasil",
          text: (response && response.msg) || "Grup berhasil dipisahkan.",
          type: "success",
          timer: 3000
        });
        if (this.$refs.dismisModal) {
          this.$refs.dismisModal.click();
        }
        this.$emit("searchData");
        this.resetForm();
      } catch (error) {
        this.errorMessage = this.getErrorMessage(
          error,
          "Grup belum dapat dipisahkan. Silakan coba lagi."
        );
      } finally {
        this.submitting = false;
      }
    },
    isConfirmed(result) {
      return Boolean(result && (result.isConfirmed || result.value === true));
    },
    resetForm() {
      this.form_data = {
        id: "",
        name: "",
        limit_per_group: minLimit,
        is_delete_original: false
      };
      this.errorMessage = "";
      this.jumlahGrup = 0;
      this.$emit("input", null);
    }
  }
};
</script>

<style scoped>
.split-group-modal .modal-content {
  border: 1px solid #e7edf5;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
}

.split-group-modal .modal-header {
  align-items: flex-start;
  padding: 18px 20px;
  border-bottom: 1px solid #eef1f4;
}

.split-title {
  display: flex;
  align-items: flex-start;
  gap: 11px;
}

.split-title-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  color: #e08b13;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 10px;
  font-size: 17px;
}

.split-title h5 {
  margin: 0 0 2px;
  color: #101828;
  font-size: 18px;
  font-weight: 700;
}

.split-title p {
  margin: 0;
  color: #667085;
  font-size: 13px;
  line-height: 1.4;
}

.split-group-modal .modal-body {
  padding: 18px 20px;
}

.split-error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 14px;
  padding: 10px 12px;
  color: #a71d2a;
  background: #fff5f5;
  border: 1px solid #f5b5b5;
  border-radius: 9px;
  font-size: 13px;
  line-height: 1.45;
}

.split-source {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(150px, 0.8fr);
  gap: 12px;
  align-items: end;
  margin-bottom: 16px;
  padding: 13px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 11px;
}

.split-field label {
  display: block;
  margin-bottom: 6px;
  color: #667085;
  font-size: 12px;
  font-weight: 600;
}

.split-field .form-control {
  min-height: 38px;
  color: #475467;
  border-color: #dfe3e8;
  border-radius: 9px;
  font-size: 14px;
}

.split-source .form-control[disabled] {
  color: #475467;
  background: #ffffff;
  opacity: 1;
}

.split-count {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 38px;
  padding: 7px 11px;
  color: #067647;
  background: #ecfdf3;
  border: 1px solid #bbf7d0;
  border-radius: 9px;
  font-size: 14px;
  font-weight: 700;
}

.split-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.3fr);
  gap: 14px;
  align-items: stretch;
  margin-bottom: 14px;
}

.split-help {
  display: block;
  margin-top: 5px;
  color: #98a2b3;
  font-size: 12px;
}

.split-toggle-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 11px;
}

.split-group-modal /deep/ .ant-switch-checked {
  background-color: #f39c12;
}

.split-toggle-copy strong {
  display: block;
  color: #344054;
  font-size: 13px;
  line-height: 1.4;
}

.split-toggle-copy small {
  display: block;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 12px;
}

.split-info {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 12px 14px;
  color: #175cd3;
  background: #eff8ff;
  border: 1px solid #b2ddff;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.5;
}

.split-info > i {
  margin-top: 2px;
  flex: 0 0 auto;
}

.split-info-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  padding: 1px 7px;
  margin: 0 2px;
  color: #8f5600;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.split-warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 12px;
  padding: 12px 14px;
  color: #a71d2a;
  background: #fff5f5;
  border: 1px solid #f5b5b5;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.5;
}

.split-warning > i {
  margin-top: 2px;
  flex: 0 0 auto;
}

.split-warning strong {
  display: block;
  margin-bottom: 2px;
}

.split-warning p {
  margin: 0;
}

.split-actions {
  padding: 14px 20px 18px;
  border-top: 1px solid #eef1f4;
}

.split-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 38px;
  padding: 0 15px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
}

.split-btn-secondary {
  color: #475467;
  background: #ffffff;
  border: 1px solid #e7edf5;
}

.split-btn-secondary:hover,
.split-btn-secondary:focus {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f6d49b;
}

.split-btn-primary {
  color: #ffffff;
  background: #f39c12;
  border: 1px solid #f39c12;
}

.split-btn-primary:hover,
.split-btn-primary:focus {
  color: #ffffff;
  background: #e08b13;
  border-color: #e08b13;
}

.split-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

@media (max-width: 767px) {
  .split-source,
  .split-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .split-group-modal .modal-content {
    max-height: calc(100vh - 16px);
    overflow-y: auto;
  }

  .split-group-modal .modal-header {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #ffffff;
  }

  .split-group-modal .modal-footer {
    position: sticky;
    bottom: 0;
    z-index: 2;
    background: #ffffff;
  }

  .split-toggle-card {
    align-items: flex-start;
  }

  .split-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .split-actions .split-btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/crm/group/formSplitGroup.vue